import React from 'react';
export const IpaIcon = (props) => (
  <svg
    className="svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    id="svg4"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs8">
      <rect
        x={164.88136}
        y={234.30508}
        width={724.61017}
        height={624.81356}
        id="rect222"
      />
    </defs>
    <text
      xmlSpace="preserve"
      id="text220"
      style={{
        fontSize: 192,
        lineHeight: 1.25,
        fontFamily: "Arial",
        letterSpacing: 0,
        wordSpacing: 0,
        whiteSpace: "pre",
        shapeInside: "url(#rect222)",
      }}
      transform="matrix(7.618875,0,0,7.1915302,-1144.07,-2047.597)"
    >
      <tspan x={164.88086} y={407.24954} id="tspan283">
        {"\u0259"}
      </tspan>
    </text>
  </svg>
);
